import React, { useState, useEffect } from 'react';
import HowItWorks from '../components/HowItWorks';
import { getWhatsAppUrl } from '../config/constants';
import usePageTitle from '../hooks/usePageTitle';
import './Portfolio.css';

const portfolioVideos = [
  {
    id: 1,
    title: 'Graduación CLT',
    description: 'Lugar CDMX',
    date: '06 de julio del 2025',
    thumbnail: '/portafolio_imgs/250706_grad/1.png',
    youtubeUrl: 'https://youtube.com/embed/DFVFh5nVe_I',
    category: 'Graduación',
  },
  {
    id: 2,
    title: 'XV años Emily',
    description: 'Lugar CDMX',
    date: '28 de septiembre 2024',
    thumbnail: '/portafolio_imgs/240928_xv/1.png',
    youtubeUrl: 'https://youtube.com/embed/M3ujrtdYjEc?feature=share',
    category: 'XV Años',
  },
  {
    id: 3,
    title: 'Boda K&C',
    description: 'Lugar CDMX',
    date: '24 de junio del 2023',
    thumbnail: '/portafolio_imgs/230624_boda/1.png',
    youtubeUrl: 'https://youtube.com/embed/FxuAfF1TnP4?feature=share',
    category: 'Bodas',
  },
  {
    id: 4,
    title: 'XV años',
    description: 'Lugar CDMX',
    date: '29 de abril del 2023',
    thumbnail: '/portafolio_imgs/230429_xv/1.png',
    youtubeUrl: 'https://youtube.com/embed/o-0BnG3IhrA?feature=share',
    category: 'XV Años',
  },
];

function Portfolio() {
  usePageTitle('Portafolio');
  const [modalOpen, setModalOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  // Cerrar modal con tecla Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && modalOpen) closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalOpen]);

  const handleVideoClick = (video) => {
    if (video.youtubeUrl) {
      setActiveVideo(video.youtubeUrl);
      setModalOpen(true);
    } else {
      alert('Video próximamente disponible');
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveVideo(null);
  };

  const handleWhatsAppContact = () => {
    window.open(
      getWhatsAppUrl('¡Hola! Vi su portafolio y me interesa contratar sus servicios para mi evento'),
      '_blank'
    );
  };

  return (
    <div className="portfolio-page">
      <div className="portfolio-hero">
        <div className="portfolio-hero-content">
          <h1>Nuestro Portafolio</h1>
          <p>
            Descubre los mejores momentos que hemos capturado en video 360°.
            Cada evento es único, cada recuerdo es especial.
          </p>
        </div>
      </div>

      <div className="container">
        <section className="portfolio-gallery section">
          <h2>Galería de Eventos</h2>
          <p className="portfolio-subtitle">
            ¡Mira cómo hemos hecho inolvidables estos momentos especiales!
          </p>

          <div className="portfolio-grid">
            {portfolioVideos.map((video) => (
              <div key={video.id} className="portfolio-card card">
                <div
                  className="video-thumbnail"
                  onClick={() => handleVideoClick(video)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleVideoClick(video)}
                  aria-label={`Ver video: ${video.title}`}
                >
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    onError={(e) => {
                      e.target.src =
                        'https://placehold.co/400x300/eb6fbd/ffffff?text=Video+Próximamente';
                    }}
                  />
                  <div className="play-overlay">
                    <div className="play-button">
                      <i className="fas fa-play"></i>
                    </div>
                  </div>
                  <div className="video-category">{video.category}</div>
                </div>

                <div className="video-info">
                  <h3>{video.title}</h3>
                  <p className="video-description">{video.description}</p>
                  <div className="video-meta">
                    <span className="video-date">
                      <i className="fas fa-calendar-alt"></i>
                      {video.date}
                    </span>
                  </div>
                  <button
                    className="btn-watch"
                    onClick={() => handleVideoClick(video)}
                  >
                    <i className="fas fa-play-circle"></i>
                    Ver video
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="portfolio-cta">
            <h3>¿Te gustó lo que viste?</h3>
            <p>¡Haz que tu evento sea el próximo en nuestro portafolio!</p>
            <button
              className="btn btn-primary btn-glow"
              onClick={handleWhatsAppContact}
            >
              ¡Quiero mi evento aquí!
            </button>
          </div>
        </section>

        <HowItWorks />
      </div>

      {/* Modal para reproducir el video */}
      {modalOpen && (
        <div
          className="video-modal-overlay"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label="Video del portafolio"
        >
          <div className="video-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-modal"
              onClick={closeModal}
              aria-label="Cerrar video"
            >
              ×
            </button>
            <div className="video-responsive">
              <iframe
                width="100%"
                height="400"
                src={activeVideo}
                title="Video de portafolio ProCam360"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Portfolio;
